<template>
	<div class="w-100 p-3 bg-white border-15">
		<div class="row">
			<div class="col-6" v-if="windowWidth>1000">
				<b class="text-success" style="font-size: 14px;">
					عنوان تیکت‌:
				</b>
				<span style="color: #676767; font-size: 14px; padding-right: 8px;">
					{{ flds.data.subject }}
				</span>
				<span v-if="flds.data.field">
					({{ flds.data.field }})
				</span>
			</div>
			<div class="col-6" v-else>
				<span 
				class="text-white p-1 border-15"
				:style="'background-color: '+read_crm[flds.data.read_crm].color+'; font-size: 12px;'"
				>
				&nbsp;
				&nbsp;
				{{ read_crm[flds.data.read_crm].name }}
				&nbsp;
				&nbsp;
				</span>
			</div>

			<div class="col-6 d-flex justify-content-end align-items-center" >
				<span 
				class="p-1 pointer"
				style="color: red; font-size: 12px;"
				@click="stop_tiket()"
				v-if="flds.data.read_crm!=4 && flds.data.read_crm!=3 && $localStorage.get('user').username.role==3"
				>
					<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12.3703 4.11347C7.65731 4.11347 3.83671 7.93407 3.83671 12.647C3.83671 17.36 7.65731 21.1805 12.3703 21.1805C17.0832 21.1805 20.9038 17.36 20.9038 12.647C20.9038 7.93407 17.0832 4.11347 12.3703 4.11347ZM2.28516 12.647C2.28516 7.07717 6.80041 2.56192 12.3703 2.56192C17.9401 2.56192 22.4554 7.07717 22.4554 12.647C22.4554 18.2168 17.9401 22.7321 12.3703 22.7321C6.80041 22.7321 2.28516 18.2168 2.28516 12.647Z" fill="#FF0000"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12.37 8.25095C12.7984 8.25095 13.1457 8.59827 13.1457 9.02672V13.1642C13.1457 13.5927 12.7984 13.94 12.37 13.94C11.9416 13.94 11.5942 13.5927 11.5942 13.1642V9.02672C11.5942 8.59827 11.9416 8.25095 12.37 8.25095Z" fill="#FF0000"/>
						<path d="M13.4046 16.2672C13.4046 16.8386 12.9415 17.3017 12.3703 17.3017C11.799 17.3017 11.3359 16.8386 11.3359 16.2672C11.3359 15.696 11.799 15.2329 12.3703 15.2329C12.9415 15.2329 13.4046 15.696 13.4046 16.2672Z" fill="#FF0000"/>
					</svg>
					نگه داشتن
				</span>
				&nbsp;
				<span 
				class="p-1 pointer"
				style="color: #676767; font-size: 12px;"
				@click="set_tiket()"
				v-if="flds.data.read_crm!=4"
				>
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M0.596671 0.819144C0.798231 0.617577 1.12502 0.617577 1.32658 0.819144L5.77883 5.27137L10.2311 0.819144C10.4326 0.617577 10.7594 0.617577 10.961 0.819144C11.1626 1.0207 11.1626 1.3475 10.961 1.54906L6.50876 6.0013L10.961 10.4536C11.1626 10.6551 11.1626 10.9819 10.961 11.1834C10.7594 11.385 10.4326 11.385 10.2311 11.1834L5.77883 6.73124L1.32658 11.1834C1.12502 11.385 0.798231 11.385 0.596671 11.1834C0.395104 10.9819 0.395104 10.6551 0.596671 10.4536L5.0489 6.0013L0.596671 1.54906C0.395104 1.3475 0.395104 1.0207 0.596671 0.819144Z" fill="#676767"/>
					</svg>
					بستن تیکت					
				</span>
				&nbsp;
				<span 
				v-if="windowWidth>1000"
				class="text-white p-1 border-15"
				:style="'background-color: '+read_crm[flds.data.read_crm].color+'; font-size: 12px;'"
				>
				&nbsp;
				&nbsp;
				{{ read_crm[flds.data.read_crm].name }}
				&nbsp;
				&nbsp;
				</span>
			</div>
			<div class="col-12" style="margin-top: 16px; margin-bottom: 8px;" v-if="windowWidth<1000">
				<b class="text-success" style="font-size: 14px;">
					عنوان تیکت‌:
				</b>
				<br>
				<span style="color: #676767; font-size: 14px;" :style="(windowWidth>1000) ? 'padding-right: 8px;' : ''">
					{{ flds.data.subject }}
				</span>
			</div>
		</div>
		<hr v-if="windowWidth>1000">
		<div class="d-e w-100 p-4 border border-15 mb-3" v-for="(f, i) in flds.data.messege" :key="i" >
			<div :class="(windowWidth>1000) ? 'd-flex' : ''">
				<div 
				class="d-flex align-items-center"
				:class="(windowWidth>1000) ? 'w-50' : 'w-100'"
				>
					<userImg
					:src="flds.data.img"
					:badge="false"
					imgSize="40px"
					vStyle="margin: unset !important; border-radius: 50% !important;"
					v-if="f.from == 'user' || f.from == 'teacher'"
					/>
					<img
						:src="require('../../assets/img/icon.svg')"
						width="40"
						v-else
					/>
					<div>
						<b class="text-14" v-if="f.from == 'user' || f.from == 'teacher'">
							&nbsp;
							{{ flds.data.teachers_fullname }}
						</b>
						<b class="text-14" v-else>
							&nbsp;
							{{ flds.data.crm }}
						</b>
						<div 
						class="text-14 text-gray d-flex align-items-center justify-content-end" 
						:class="(windowWidth>1000) ? 'w-50' : 'w-100'"
						v-if="windowWidth<1000"
						>
							{{ f.date }}
						</div>
					</div>
				</div>
				<div 
				class="text-14 text-gray d-flex align-items-center justify-content-end" 
				:class="(windowWidth>1000) ? 'w-50' : 'w-100'"
				v-if="windowWidth>1000"
				>
					{{ f.date }}
				</div>
			</div>
			<div class="w-100 text-justify text-14 text-gray">
				{{ f.message }}
				<br>
				<div v-if="f.files" class="p-2 d-flex">
					<div v-for="(file, j) in f.files" :key="j" class="mr-1">
						<a class="border border-15 p-1" target="_blank" :href="imgurl+file.fileUpload">{{file.fileName}} &nbsp; <img :src="require('../../assets/img/Download.svg')" width="16" />&nbsp;</a>
					</div>
				</div>
			</div>
		</div>
</div>
</template>

<script>
	import btn from  "../../UI/button/btn.vue";
	import userImg from  "../../UI/userImg/userImg.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";
	import selectInput from  "../../UI/input/selectInput.vue";
	import file_cloud_lg from  "../../UI/uploadFile/file_cloud_lg.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";
	import * as read_crm_json from  "../ticket_list/read_crm.json";
	import * as importances_json from  "../ticket_list/importances.json";
	


	export default {
		name: 'ticket_id_part1',
		data(){
			return {
				loading: loading,
				success_sm: success_sm,
				success: success,
				error: error,
				imgurl: window.imgurl,
				val : {
					'subject': '-1',
					'importance': '-1',
					'message': '',
					'files': [],
				},
				read_crm: read_crm_json.default,
				importances: importances_json.default
			}
		},
		components: {
			btn,
			userImg,
			selectInput,
			textareaInput,
			file_cloud_lg,
		},
		props: {
			flds: {
				default: [],
			},
		},
		mounted(){
			
		},
		methods:{
			set_tiket(){
				this.$swal.fire({
					position: 'center',
					type: 'error',
					title: "از بستن تیکت خود اطمینان دارید؟",
					showCloseButton: true,
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: "بلی",
					cancelButtonText: "خیر",
					confirmButtonColor: "#1b60c6",
					cancelButtonColor: "#E90000",
				}).then((result) => {
					if(result.value){
						this.close_ticket()
					}
				});
			},
			// ----------------------------------------------------
			stop_tiket(){
				this.$swal.fire({
					position: 'center',
					type: 'error',
					title: "از نگه داشتن تیکت خود اطمینان دارید؟",
					showCloseButton: true,
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: "بلی",
					cancelButtonText: "خیر",
					confirmButtonColor: "#1b60c6",
					cancelButtonColor: "#E90000",
				}).then((result) => {
					if(result.value){
						this.close_ticket("stop")
					}
				});
			},
			// ----------------------------------------------------
			close_ticket(status='cancel', THIS=this){
				window.$.post(window.baseurl+'ticket/'+this.$route.params.id, {
					status: status, 
					token: this.$localStorage.get("user")
				}, function(D){
					THIS.success(THIS, "ثبت شد")
					THIS.$emit('loader', D);
				}, "json");					
			},
			// ----------------------------------------------------
		}
	}
</script>
<style>
.d-e:nth-child(odd){
	background-color:#fff;
}
.d-e:nth-child(even){
	background-color: #F5FAFD;
}
</style>